import { routes, apiClient } from 'common/services';
import { type ApiClientResponse } from 'common/services/deprecatedApi';

export const deleteCurrentUser = async (deleteReason: string) =>
  apiClient.post<void, ApiClientResponse<void>>(routes.user.delete, { reason: deleteReason });
